// extracted by mini-css-extract-plugin
module.exports = {"modalProTable":"index_modalProTable__1WVq1"};